import API from '@aws-amplify/api';
export default (function () {
  var requestId = 0;
  var pendingRequests = {};
  var cache = {};

  var isLoading = function isLoading() {
    return !!Object.keys(pendingRequests).length;
  };

  var makeRequest = function makeRequest(method) {
    return function () {
      var id = requestId++;
      pendingRequests[id] = true;
      return API[method].apply(API, arguments)["finally"](function () {
        delete pendingRequests[id];
      });
    };
  };

  return {
    get: makeRequest('get'),
    post: makeRequest('post'),
    patch: makeRequest('patch'),
    put: makeRequest('put'),
    del: makeRequest('del'),
    getCache: function getCache(key) {
      return cache[key];
    },
    setCache: function setCache(key, value) {
      return cache[key] = value;
    },
    isLoading: isLoading
  };
});